import { FunctionComponent } from 'react';
import { InjectedClientSideConfig } from '../GetServerSideProps/ConfigServerSidePropsProvider';

/**
 * Next 15 sunsets the old publicRuntimeConfig config API, but we can re-create it by injecting the config into the DOM
 * via a script tag.
 */
export const ClientSideConfigInjector: FunctionComponent<InjectedClientSideConfig> = ({ clientSideConfig: config }) => (
    <script
        dangerouslySetInnerHTML={{
            __html: `
        window.clientRuntimeConfig = ${JSON.stringify(config)};
        `,
        }}
    />
);
